import React from 'react'

const CateringMenuDesktop = () => {
    return (
        <div>CateringMenuDesktop</div>
    )
}

export default CateringMenuDesktop